import { useEffect } from "react";

export default function usePageTitle(title) {
  useEffect(() => {
    if (title) document.title = `${title} — Ayurvedam.com`;
    return () => {
      document.title = "Ayurvedam.com — Independent Ayurveda Authority";
    };
  }, [title]);
}
